import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { ConversationService } from 'src/app/services/conversation.service';
import { ProjectService } from 'src/app/services/project.service';
import { Conversation } from 'src/app/shared/models/conversation.model';
import { data } from './demo_data';
import { GenerateNewReportComponent } from 'src/app/shared/components/report-generation/generate-new-report/generate-new-report.component';

@Component({
    selector: 'app-conversation-page',
    templateUrl: './conversation-page.component.html',
    styleUrl: './conversation-page.component.scss',
    standalone: false
})
export class ConversationPageComponent implements OnInit, OnDestroy {
	@ViewChild('generateNewReport') generateNewReportModal!: GenerateNewReportComponent;
	private dotsSubscription!: Subscription;
	private dataSubscription!: Subscription;

	conversationID!: number;
	projectId!: number;
	conversation!: Conversation;

	loadingPageData = false;
	loading = false;

	startedUpload = false;
	startedRecord = false;
	liveStatus = false;

	dots = '';
	progress = 0;
	showLoadingData = false;
	conversationData!: any;
	allowSpecial = false;

	page_data: any = null;

	targetReportId: string | null = null;

	constructor(private route: ActivatedRoute, private router: Router, private projectService: ProjectService, private conversationService: ConversationService, private authService: AuthService) {}

	ngOnInit(): void {
		this.loading = true;
		this.projectService.setLeftSideBar(true);
		this.allowSpecial = this.authService.currentClientValue.roles.includes('RESTRICTED');

		this.route.params.subscribe((params: any) => {
			this.conversationID = params.conversationid;
			this.projectId = params.projectid;

			this.page_data = {
				project_id: this.projectId,
				conversation_id: this.conversationID
			}
			
			this.getDetails();
		});
	}

	ngOnDestroy(): void {
		this.projectService.setLeftSideBar(false);

		if (this.dotsSubscription) {
      this.dotsSubscription.unsubscribe();
    }

		if (this.dataSubscription) {
			this.dataSubscription.unsubscribe();
		}

		if (this.conversationService.sseSubscription) {
			this.conversationService.sseSubscription.unsubscribe();
		}
	}

	goBack() {
		this.router.navigate(['/projects/' + this.projectId], { queryParams: { 'tab': 'conversations' } });
	}

	openGenerateNewReportModal() {
		this.generateNewReportModal.openModal(this.conversation.extra_content.analyze_version);
	}

	handleUpdateReports(event: any) {
		this.conversation = { ...this.conversation, ...event.entity };
		if (this.conversation.status === 'ANALYZING' || this.conversation.status === 'STARTED') {
			this.getDetails();
		} else {
			if (event.reportId) {
        this.targetReportId = event.reportId;
      }
		}
	}

	getDetails() {
		this.conversationService.getProjectConversation(this.projectId, this.conversationID).subscribe({
			next: (response) => {
				this.loading = false;
				this.loadingPageData = false;
				this.conversation = response;

				if (this.conversation.status === 'ANALYZING' || this.conversation.status === 'STARTED') {
					this.dotsSubscription = interval(500).subscribe(() => {
						this.dots += '.';
						if (this.dots.length > 3) {
							this.dots = '';
						}
					});
				} else {
					if (this.dotsSubscription) {
						this.dotsSubscription.unsubscribe();
					}
				}

				if (this.conversation.status === 'COMPLETED') {
					// this.conversationData = data;
					this.showLoadingData = true;
					this.dataSubscription = this.conversationService.getProgressConversationDataSubject().subscribe({
						next: (data) => {
							this.progress = data.progress;
							if (data.data) {
								this.conversationData = data.data;
								this.showLoadingData = false;
								this.dataSubscription.unsubscribe();
							}
						}
					});
					this.conversationService.getProjectConversationData(this.projectId, this.conversationID);
				}
			},
			error: (err) => {
				this.authService.toastErrorMessage(err.message ? err.message : err, 'Fetching Error');
				this.goBack();
			}
		});
	}

	chooseAction(file_type: string) {
		this.loadingPageData = true;
		this.conversationService.updateConversation(this.projectId, this.conversationID, { file_type: file_type }).subscribe({
			next: () => {
				this.getDetails();
			},
			error: (err) => {
				this.authService.toastErrorMessage(err.message ? err.message : err, 'Updating Error');
			}
		});
	}

	onUploadStart(event: boolean) {
		this.startedUpload = event;
	}

	onRecordStart(event: boolean) {
		this.startedRecord = event;
	}

	onUploadComplete() {
		this.loadingPageData = true;
		this.getDetails();
	}
}
